<strong mat-dialog-title>Proficiency Levels</strong>
<mat-dialog-content>
  <table class="mat-table">
    <tbody>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Willing to learn</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">
          No skills or experience, can commit to learning
        </td>
      </tr>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Student</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">Can work with little oversight</td>
      </tr>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Proficient</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">Can work independently and assist others</td>
      </tr>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Teacher</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">Can provide oversight and teach</td>
      </tr>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Leader</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">Thought leader</td>
      </tr>
      <tr class="mat-row">
        <td class="mat-cell">
          <strong>Moved On</strong>
        </td>
        <td class="mat-cell">-</td>
        <td class="mat-cell">Experienced, but not willing to work anymore</td>
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Got It!</button>
</mat-dialog-actions>
